import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

type ImageProps = {
    imageName: string
    width: number | string
}

const Image = ({ imageName, width }: ImageProps) => {
    const query = graphql`
        query Images {
            images: allFile(filter: { extension: { regex: "/images/*.jpeg|jpg|png/" } }) {
                edges {
                    node {
                        name
                        childImageSharp {
                            fluid(maxWidth: 700, quality: 100) {
                                ...GatsbyImageSharpFluid
                            }
                        }
                    }
                }
            }
        }
    `
    const data = useStaticQuery(query)
    if (!imageName) {
        return null
    }

    const imgData = data.images.edges.find((img: any) => img.node.name === imageName)
    return <Img style={{ width }} fluid={imgData.node.childImageSharp.fluid} />
}
export default Image
